<template>
  <RouterView />
  <!--
    Toasts open below the fixed header, not over it: at Aura's default 20px
    offset they covered the User menu and Notifications buttons for their whole
    life, hiding a control that took focus (WCAG 2.4.11).
  -->
  <Toast position="top-right" :pt="toastPt" />
  <ConfirmDialog />
</template>

<script setup lang="ts">
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';

const toastPt = {
  root: { style: { top: 'calc(var(--header-height) + var(--space-2))' } },
  // A detail carrying "\n" shows one line each (the waiting list's skipped invites).
  detail: { style: { whiteSpace: 'pre-line' } },
};
</script>
